import { SpaceContext } from '@eggplant/context'
import { SHARED_SPACE_ID } from '@eggplant/routing'
import { useContext } from 'react'

export const useGetParamsWithSpaceId = <T>(params: T) => {
  const spaceContext = useContext(SpaceContext)

  if (import.meta.env.VITE_IS_AUTH_DISABLED === 'true') // do not add spaceId into test environments (eg. cypress)
  {
    const requestParams = params

    return { requestParams }
  }

  const spaceId = spaceContext?.selectedSpaceId || SHARED_SPACE_ID

  const requestParams = params
    ? {
      ...params,
      space_id: spaceId
    }
    : {
      space_id: spaceId
    }

  return { requestParams }
}
